export enum SCREEN_SIZE {
    XXS,
    XS,
    SM,
    MD,
    LG,
    XL,
    XXL,
    XXXL
}
